export default __webpack_public_path__ + "static/media/pv.cdd4b723.svg";